module.exports = __webpack_public_path__ + "static/amnesty-33b8c964cc79568d3e41e2535d805f8b.png";